// Общие DOM-атрибуты и таймауты drag-and-drop слоя.
// Используются и HTML5 DnD путём (VariantColumn/VariantsBoard), и тач-фолбэком (useTouchDrag),
// чтобы оба пути находили одни и те же зоны и узнавали позицию вставки одинаково.

/** На контейнере варианта — его id. Главная drop-зона колонки. */
export const DROP_VARIANT_ATTR = 'data-drop-variant';

/** На карточке сегмента внутри таймлайна — её текущий индекс в variant.segmentIds.
 *  Индекс вставки вычисляется сравнением курсора с центром такой карточки. */
export const DROP_INDEX_ATTR = 'data-drop-index';

/** На фоне рабочей области и на явной зоне «убрать из варианта». Drop здесь = removeFromVariant. */
export const DROP_REMOVE_ATTR = 'data-drop-remove';

/** На перетаскиваемом элементе — id сегмента (используется глобальным слушателем dragstart). */
export const SEGMENT_ID_ATTR = 'data-segment-id';

/** Значение SEGMENT_DND_MIME из src/ui/library/constants.ts — держим свою копию,
 *  чтобы src/ui/dnd не зависел от src/ui/library (dnd — более низкий слой). Значение
 *  зафиксировано контрактом (CONTRACT.md), менять только синхронно с library. */
export const SEGMENT_DND_MIME = 'application/x-segment-id';

/** Долгое нажатие для тач-фолбэка, мс. */
export const LONG_PRESS_MS = 350;

/** Порог движения до срабатывания long-press, px — больше = это скролл, а не драг. */
export const MOVE_CANCEL_PX = 8;
